module.exports = {
  label: {
    vendor: 'Intrising',
    appName: 'IntriCloud'
  },
  color: {
    theme: 'hsl(350,66%,44%)'
  }
}



// WEBPACK FOOTER //
// ./src/sass/_variables/intrising.js